// src\themes\choopar\components\ProductView.tsx
import Container from "@/components/shared/Container";
import { ShopTag } from "@/core/models/shop-tag-model";
import Link from "next/link";
import ProductGallery from "../elements/Product/ProductGallery";
import RelatedProducts from "@/themes/choopar/elements/Product/RelatedProducts";
import { MainShopProduct, ProductColor } from "@/core/models/shop-product-model";
import WidgetsRender from "@/components/main/widgets/WidgetsRender";
import ProductInformation from "../elements/Product/ProductInformation";
import ProductComments from "@/themes/default/elements/comment/ProductComment";

interface GalleryData {
    image_info: Array<{
        url: string;
        alt?: string;
    }>;
}

interface ProductViewProps {
    product: MainShopProduct;
    gallery: GalleryData;
    colors: ProductColor[];
    id: number;
}

export default function ProductView({ product, gallery, colors, id }: ProductViewProps) {


    console.log(product.blog);

    return (
        <Container className="flex flex-col gap-12 mt-22 px-4">
            <div className="grid grid-cols-7 gap-8">
                <div className="col-span-7 md:col-span-4">
                    {product.thumbnail && (
                        <ProductGallery images={gallery.image_info} product={product} />
                    )}
                </div>
                <aside className="col-span-7 md:col-span-3 sticky top-20 h-fit">
                    <ProductInformation product={product} colors={colors} />
                </aside>
            </div>
            {product.tags && product.tags.length > 0 && (
                <div className="flex flex-wrap gap-2 my-2.5">
                    {product.tags.map((tag: ShopTag) => (
                        <Link
                            key={tag.id}
                            href={`/shop/category/products/all?tag=${tag.slug}`}
                            className="inline-block px-3 py-1.5 bg-primary-200 text-primary-900 text-sm rounded-xs hover:bg-primary-300 transition-colors no-underline"
                        >
                            #{tag.title}
                        </Link>
                    ))}
                </div>
            )}
            {
                product.blog &&
                <div className="grid grid-cols-12 gap-x-4 gap-y-11 md:gap--x-13 md:gap-y-13 lg:gap-y-18 lg:gap-x-18 mx-auto w-full">
                    <WidgetsRender widgets={product.blog.content} />
                </div>
            }
            <RelatedProducts productId={id} />
            <ProductComments productId={id} />
        </Container>
    )
}
